<template>
    <div class="container">
        <el-page-header @back="$router.back()" content="个人办赛的赛事审核"></el-page-header>
        <div class="content">
            <el-alert
                title="审核不通过原因："
                :description="(editInfo.AuditReason || '')"
                type="warning"
                effect="dark"
                show-icon
                :closable="false"
                style="margin-bottom:30px"
                v-if="editInfo && [5, 6].includes(editInfo.LeagueNowStatus)">
            </el-alert>
            <el-descriptions title="赛事基本信息" :column="1" :labelStyle="{'width':'100px','justify-content': 'end','padding-right':'12px','margin-right':'0','box-sizing':'border-box'}">
                <el-descriptions-item label="申请人" v-if="creater">{{creater.Phone}} {{creater.Name}}</el-descriptions-item>
                <el-descriptions-item label="运动项目">{{leagueInfo.EventsName || '无'}}</el-descriptions-item>
                <el-descriptions-item label="赛事全称">{{leagueInfo.LeagueFullName}}</el-descriptions-item>
                <el-descriptions-item label="赛事简称">无</el-descriptions-item>
                <el-descriptions-item label="比赛形式">线下赛</el-descriptions-item>
                <el-descriptions-item label="赛事logo">无</el-descriptions-item>
                <el-descriptions-item label="封面照片">
                    <img :src="leagueInfo.CoverUrl" style="height:100px;" v-if="leagueInfo.CoverUrl" @click="lookImage(leagueInfo.CoverUrl)"/>
                    <span v-else>默认</span>
                </el-descriptions-item>
                <el-descriptions-item label="特殊状态">无（正常）</el-descriptions-item>
                <el-descriptions-item label="比赛时间">
                    <span v-if="leagueInfo.GameTime">{{formatDate(leagueInfo.GameTime.BeginTime)}} ~ {{formatDate(leagueInfo.GameTime.EndTime)}}</span>
                    <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="比赛地点">
                    <div style="width: 100%;max-width: 700px;display:flex;flex-wrap: wrap;">
                        <el-tag
                            v-for="(item,index) in leagueInfo.GamePlace" :key="index"
                            effect="plain" size="small"
                            style="margin-right:10px;margin-bottom:5px"
                        >
                            {{item.RegionName}}
                        </el-tag>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item :label="item.Kind" v-for="(item,index) in Units" :key="index" >
                    <div style="width: 100%;max-width: 700px;display:flex;flex-wrap: wrap;">
                        <el-tag
                            v-for="(unitItem,unitIndex) in item.Units" :key="unitIndex"
                            effect="plain" size="small"
                            style="margin-right:10px;margin-bottom:5px"
                        >
                            {{unitItem}}
                        </el-tag>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="竞赛规程">
                    <div style="width: 100%">
                        <Editor :value="leagueInfo.Comment" v-if="leagueInfo.Comment" disabled></Editor>
                        <div class="image_list" v-if="leagueInfo.PictureFiles">
                            <div class="img" v-for="item,index in leagueInfo.PictureFiles" :key="index">
                                <img :src="item.FileUrl" @click="lookImage(item.FileUrl, leagueInfo.PictureFiles.map(item=>item.FileUrl))">
                            </div>
                        </div>
                        <div class="file_list" v-if="leagueInfo.DocFiles">
                            <el-card class="file_container" title="点击下载文档附件" v-for="item,index in handleDocFiles" :key="index">
                                <div class="file" @click="downloadFile(item)">
                                    <div class="icon" :class="item.className"></div>
                                    <div class="file_info">
                                        <div class="file_name">{{item.name}}</div>
                                        <div class="file_size">{{item.size}}</div>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </el-descriptions-item>
            </el-descriptions>
            <el-divider></el-divider>
            <el-descriptions title="赛事分组信息"></el-descriptions>
            <el-card shadow="never" v-for="(item,index) in handleEventsGroupList" :key="index" style="width:100%;max-width: 1200px;box-sizing: border-box;margin-bottom:20px">
                <el-descriptions :column="1" :labelStyle="{'width':'100px','flex': 'none','justify-content': 'end','padding-right':'12px','margin-right':'0','box-sizing':'border-box'}">
                    <el-descriptions-item label="比赛项目">{{item.Name}}</el-descriptions-item>
                    <el-descriptions-item label="分组">
                        <el-table :data="item.groups" border size="mini">
                            <el-table-column
                                label="名称"
                                width="180"
                                align="center">
                                <template slot-scope="scope">{{scope.row.GroupName}}</template>
                            </el-table-column>
                            <el-table-column
                                label="类型"
                                width="120"
                                align="center">
                                <template slot-scope="scope">{{getGroupTypeText(scope.row)}}</template>
                            </el-table-column>
                            <el-table-column
                                label="性别限制"
                                width="80"
                                align="center">
                                <template slot-scope="scope">{{getGroupSexText(scope.row)}}</template>
                            </el-table-column>
                            <el-table-column
                                label="年龄限制"
                                align="center">
                                <template slot-scope="scope">{{getGroupAgeText(scope.row)}}</template>
                            </el-table-column>
                            <el-table-column
                                label="人数限制"
                                align="center">
                                <template slot-scope="scope">{{getGroupNumberText(scope.row)}}</template>
                            </el-table-column>
                        </el-table>
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>
            <el-divider></el-divider>
            <el-descriptions title="报名信息设置" :column="1" :labelStyle="{'width':'100px','justify-content': 'end','padding-right':'12px','margin-right':'0','box-sizing':'border-box'}">
                <el-descriptions-item label="报名时间">
                    <span v-if="enrollInfo.EnrollTime">{{formatDate(enrollInfo.EnrollTime.BeginTime)}} ~ {{formatDate(enrollInfo.EnrollTime.EndTime)}}</span>
                    <span v-else>未定</span>
                </el-descriptions-item>
                <el-descriptions-item label="报名须知">
                    <div style="width: 100%">
                        <Editor :value="enrollInfo.EnrollNotice" v-if="enrollInfo.EnrollNotice" disabled></Editor>
                        <div class="image_list" v-if="enrollInfo.PictureFiles">
                            <div class="img" v-for="item,index in enrollInfo.PictureFiles" :key="index">
                                <img :src="item.FileUrl" @click="lookImage(item.FileUrl, enrollInfo.PictureFiles.map(item=>item.FileUrl))">
                            </div>
                        </div>
                        <div class="file_list" v-if="enrollInfo.DocFiles">
                            <el-card class="file_container" title="点击下载文档附件" v-for="item,index in handleEnrollDocFiles" :key="index">
                                <div class="file" @click="downloadFile(item)">
                                    <div class="icon" :class="item.className"></div>
                                    <div class="file_info">
                                        <div class="file_name">{{item.name}}</div>
                                        <div class="file_size">{{item.size}}</div>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="法律文件">
                    <div class="file_list" v-if="enrollInfo.Instruments">
                        <el-card class="file_container" title="点击下载文档附件" v-for="item,index in handleInstruments" :key="index">
                            <div class="file" @click="downloadFile(item)">
                                <div class="icon" :class="item.className"></div>
                                <div class="file_info">
                                    <div class="file_name">{{item.name}}</div>
                                </div>
                            </div>
                        </el-card>
                    </div>
                    <span v-else>默认</span>
                </el-descriptions-item>
                <el-descriptions-item label="队员信息设置">
                    <el-card shadow="never" style="width:100%;max-width:700px;box-sizing: border-box;margin-bottom:20px">
                        <el-descriptions :column="1" :labelStyle="{'width':'100px','justify-content': 'end','padding-right':'12px','margin-right':'0','box-sizing':'border-box'}">
                            <el-descriptions-item label="球衣号码">{{fieldsOptions.jersey_number == 0 ? '不使用' : '运动员必填，其他身份不要求必填'}}</el-descriptions-item>
                            <el-descriptions-item label="照片">{{fieldsOptions.portrait_photo == 0 ? '不要求必需上传' : '运动员必须上传，其他身份不要求上传'}}</el-descriptions-item>
                            <el-descriptions-item label="身份证号码">{{fieldsOptions.identity_limit == 0 ? '不要求必填' : '运动员必填，其他身份不要求必填'}}</el-descriptions-item>
                            <el-descriptions-item label="性别">{{fieldsOptions.sex_limit == 0 ? '不要求必填' : '运动员必填，其他身份不要求必填'}}</el-descriptions-item>
                            <el-descriptions-item label="出生日期">{{fieldsOptions.birthday_limit == 0 ? '不要求必填' : '运动员必填，其他身份不要求必填'}}</el-descriptions-item>
                        </el-descriptions>
                    </el-card>
                </el-descriptions-item>
            </el-descriptions>
            <template  v-if="editInfo.LeagueNowStatus == 5">
                <el-divider></el-divider>
                <el-row style="margin:30px 0 20px 100px">
                    <el-button type="primary" style="width:120px" @click="aduit(true)">通过审核</el-button>
                    <el-button type="danger" style="width:120px" @click="aduit(false)">不通过审核</el-button>
                </el-row>
            </template>
            
        </div>
        <el-image ref="imagePreview" class="image_preview"
            :src="imageUrl" 
            :preview-src-list="imagePreviews">
        </el-image>
    </div>
</template>
<script>
import {
    GetSubleagueDetail
} from '@/newApi';
import {
    formatFileSize
} from '@/common/tools';
import Editor from '@/components/Editor';
import { toQueryString } from '@/assets/js/util'
export default {
    components: { 
        Editor
    },
    data(){
        return {
            token: this.$cookies.get('token'),
            subLeagueId: 0,
            editInfo: {},
            personalLeagueInfo: {},
            creater: null,
            imagePreviews:[],
            imageUrl: ''
        }
    },
    created(){
        let subLeagueId = +(this.$route.params.leagueId || 0);
        this.subLeagueId = subLeagueId;
        this.getDetail();
    },
    computed: {
        groups(){
            return this.personalLeagueInfo.GroupInfo || [];
        },
        groupTypes(){
            return [
                { value: 1, label: '个人' },
                { value: 2, label: '团体' },
                { value: 3, label: '双人组合' }
            ];
        },
        leagueInfo(){
            return this.personalLeagueInfo.LeagueInfo || {};
        },
        enrollInfo(){
            return this.personalLeagueInfo.EnrollInfo || {};
        },
        fieldsOptions(){
            return this.enrollInfo.FieldsOptions || {};
        },
        Units(){
            // if(!this.editInfo.AllUnits) return;
            // let units = this.editInfo.AllUnits;
            // return units;
            if(!this.leagueInfo.Units) return;
            let {
                Host,
                Undertaker
            } = this.leagueInfo.Units;
            let units = [
                { Kind: '主办单位', Units: Host.split(' ') }
            ]
            if(Undertaker){
                units.push({ Kind: '承办单位', Units: Undertaker.split(' ') });
            }
            return units;
        },
        handleEventsGroupList(){
            let eventsList = [];
            this.groups.forEach(groupItem=>{
                let obj = eventsList.find(item=>item.Id == groupItem.EventsId);
                if(obj){
                    obj.groups.push(groupItem);
                }else{
                    eventsList.push({
                        Id: groupItem.EventsId,
                        Name: groupItem.EventsName,
                        groups: [groupItem]
                    })
                }
            })
            return eventsList;
        },
        
        handleDocFiles(){
            if(!this.leagueInfo.DocFiles) return;
            return this.leagueInfo.DocFiles.map(item=>{
                let name = item.FileName,
                    url = item.FileUrl;
                let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
                if(!type){
                    type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
                }
                let className = type;
                if(['docx', 'doc'].includes(type)){
                    className = 'word';
                }else if(['xlsx', 'xls'].includes(type)){
                    className = 'excel';
                }else if(['pptx', 'ppt'].includes(type)){
                    className = 'ppt';
                }else if(['pdf'].includes(type)){
                    className = 'pdf';
                }
                return {
                    url,
                    name,
                    size: formatFileSize(item.FileSize),
                    className
                }
            })
        },
        
        handleEnrollDocFiles(){
            if(!this.enrollInfo.DocFiles) return;
            return this.enrollInfo.DocFiles.map(item=>{
                let name = item.FileName,
                    url = item.FileUrl;
                let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
                if(!type){
                    type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
                }
                let className = type;
                if(['docx', 'doc'].includes(type)){
                    className = 'word';
                }else if(['xlsx', 'xls'].includes(type)){
                    className = 'excel';
                }else if(['pptx', 'ppt'].includes(type)){
                    className = 'ppt';
                }else if(['pdf'].includes(type)){
                    className = 'pdf';
                }
                return {
                    url,
                    name,
                    size: formatFileSize(item.FileSize),
                    className
                }
            })
        },
        
        handleInstruments(){
            if(!this.enrollInfo.Instruments) return;
            return this.enrollInfo.Instruments.map(item=>{
                let name = item.InstrumentName,
                    url = item.InstrumentUrl;
                let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
                if(!type){
                    type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
                }
                let className = type;
                if(['docx', 'doc'].includes(type)){
                    className = 'word';
                }else if(['xlsx', 'xls'].includes(type)){
                    className = 'excel';
                }else if(['pptx', 'ppt'].includes(type)){
                    className = 'ppt';
                }else if(['pdf'].includes(type)){
                    className = 'pdf';
                }
                return {
                    url,
                    name,
                    className
                }
            })
        },
    },
    methods: {
        formatDate(value){
            if(!value) return '';
            return new Date(value).format('yyyy-MM-dd HH:mm');
        },
        getDetail(){
            GetSubleagueDetail({
                SubLeagueId: this.subLeagueId
            }).then(data=>{
                if(data.Code == 0){
                    this.editInfo = data.EditInfo || {};
                    if(data.PersonalLeague){
                        this.personalLeagueInfo = data.PersonalLeague.LeagueDetail || {};
                        this.creater = data.PersonalLeague.Creater;
                    }
                }
            })
        },
        lookImage(url, urls){
            if(!url) return;
            if(!urls){
                urls = [url];
            }
            this.imagePreviews = urls;
            this.imageUrl = url;
            this.$refs.imagePreview.showViewer = true;
        },
        downloadFile(data){
            this.$file.download(data.url, data.name);
        },
        aduit(isPass){
            if(isPass){
                this.$confirm('确认审核通过？', '审核通过', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.aduitApi();
                })
            }else{
                this.$prompt('审核不通过的原因：', '审核不通过', {
                    confirmButtonText: '审核不通过',
                    cancelButtonText: '取消',
                    inputType: 'textarea',
                    inputValue: this.editInfo.AuditReason || '',
                    inputValidator:(value)=>{
                        if(!value){
                            return '请输入审核不通过的原因';
                        }
                    }
                }).then(({ value }) => {
                    this.aduitApi(value);
                })
            }
        },
        aduitApi(reason = ''){
            let loading = this.$loading({
                lock: true,
                text: '提交中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            this.$axios.post('Match/Entrance', toQueryString({
                action: 'Upt_league_status',
                type: 3,
                league_id: this.subLeagueId,
                enroll_type: 0,
                user_token: this.token,
                audit_reason: reason,
                masters_score_type: ''
            })).then((res) => {
                loading.close();
                let data = res.data;
                if(data.code == -200) {
                    this.$alert('登录失效，请刷新重新登录', '提示', {
                        confirmButtonText: '刷新'
                    }).then(() => {
                        this.clearCookie()
                        this.refresh()
                    })
                } else if(data.code == 1) {
                    this.$alert('提交成功', '提示', {
                        confirmButtonText: '返回列表'
                    }).then(() => {
                        this.$router.push('/match/pass')
                    })
                } else {
                    this.$message.error(data.message);
                }
            }).catch(() => {
                loading.close();
                this.$message.error('网络异常');
            })
        },
        getGroupTypeText(groupItem){
            return (this.groupTypes.find(item=>item.value == groupItem.GroupType) || {}).label + (groupItem.IsHonored ? '，嘉宾' : '');
        },
        getGroupSexText(groupItem){
            let sexList = [];
            if(groupItem.GroupType == 1){
                sexList = [
                    {label: '男女不限', value: 3},
                    {label: '男子', value: 1},
                    {label: '女子', value: 2}
                ]
            }else if(groupItem.GroupType == 2){
                sexList = [
                    {label: '男子', value: 1},
                    {label: '女子', value: 2},
                    {label: '混合', value: 3}
                ]
            }else if(groupItem.GroupType == 3){
                sexList = [
                    {label: '男女不限', value: 3},
                    {label: '男双', value: 1},
                    {label: '女双', value: 2},
                    {label: '混双', value: 4}
                ]
            }
            let {
                GenderLimit
            } = groupItem.GroupEnrollSetting || {};
            return (sexList.find(item=>item.value == GenderLimit) || {}).label || '';
        },
        getGroupAgeText(groupItem){
            let {
                GenderLimit,
                MaleAgeMin,
                MaleAgeMax,
                FemaleAgeMin,
                FemaleAgeMax
            } = groupItem.GroupEnrollSetting || {};
            if(GenderLimit == 1){
                if(MaleAgeMin || MaleAgeMax){
                    return `${MaleAgeMin || 0}~${this.handleNumber(MaleAgeMax)}`;
                }else{
                    return '不限';
                }
            }else if(GenderLimit == 2){
                if(FemaleAgeMin || FemaleAgeMax){
                    return `${FemaleAgeMin || 0}~${this.handleNumber(FemaleAgeMax)}`;
                }else{
                    return '不限';
                }
            }else {
                let text = '';
                if(MaleAgeMin || MaleAgeMax){
                    text += `男子：${MaleAgeMin || 0}~${this.handleNumber(MaleAgeMax)}，`;
                }else{
                    text += '男子不限，';
                }
                if(FemaleAgeMin || FemaleAgeMax){
                    text += `女子：${FemaleAgeMin || 0}~${this.handleNumber(FemaleAgeMax)}`;
                }else{
                    text += '女子不限';
                }
                return text;
            }
        },
        getGroupNumberText(groupItem){
            let {
                GenderLimit,
                AthletesMin,
                AthletesMax,
                MaleAthletesMin,
                MaleAthletesMax,
                FemaleAthletesMin,
                FemaleAthletesMax
            } = groupItem.GroupEnrollSetting || {};
            if(groupItem.GroupType == 1){
                return AthletesMax > 0 ? `每队最多报名${AthletesMax}人` : '每队报名人数不限';
            }else if(groupItem.GroupType == 3){
                return AthletesMax > 0 ? `每队最多报名${AthletesMax}对` : '每队报名对数不限';
            }else{
                if(GenderLimit == 1){
                    if(MaleAthletesMin || MaleAthletesMax){
                        return `${MaleAthletesMin || 0}~${this.handleNumber(MaleAthletesMax)}`;
                    }else{
                        return '不限';
                    }
                }else if(GenderLimit == 2){
                    if(FemaleAthletesMin || FemaleAthletesMax){
                        return `${FemaleAthletesMin || 0}~${this.handleNumber(FemaleAthletesMax)}`;
                    }else{
                        return '不限';
                    }
                }else{
                    let text = '';
					text += '总人数';
                    if(AthletesMin || AthletesMax){
                        text += `${AthletesMin || 0}~${this.handleNumber(AthletesMax)};`;
                    }else{
                        text += '不限;';
                    }
                    if(MaleAthletesMin || MaleAthletesMax){
						text += `男子${MaleAthletesMin || 0}~${this.handleNumber(MaleAthletesMax)};`;
					}else{
						text += '男子不限;';
					}
					if(FemaleAthletesMin || FemaleAthletesMax){
						text += `女子${FemaleAthletesMin || 0}~${this.handleNumber(FemaleAthletesMax)};`;
					}else{
						text += '女子不限;';
					}
                    return text;
                }
            }
        },
        handleNumber(number){
            return number || '不限';
        }
    }
}
</script>
<style scoped>
@import "~@/assets/css/clear-el.css";
.el-card::v-deep .el-card__body{
    padding: 20px 10px 10px 0px !important;
}

.el-descriptions::v-deep .el-descriptions-item__content{
    width: 100%;
}
.el-descriptions::v-deep .el-descriptions-item__content .editor{
    width: 100%;
    margin-bottom: 8px;
}
.images{
    width: 100%;
}
.images img{
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    object-fit: contain;
    cursor: pointer;
}
.files{
    display: flex;
    flex-wrap: wrap;
}
.files .file_item{
    width: 300px;
    height: 54px;
    padding: 8px 12px;
    box-sizing: border-box;
    background: #FAFBFA;
    border-radius: 6px;
    margin-right: 8px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.files .file_item .file_icon{
    width: 38px;
    height: 38px;
    background: url('~@/assets/icon/file_pdf.png') no-repeat center / 100%;
}
.files .file_item .file_info{
    width: calc(100% - 38px);
    padding-left: 6px;
    box-sizing: border-box;
}
.files .file_item .file_name{
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    color: #3A3F49;
    line-height: 22px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.files .file_item .file_size{
    font-weight: 400;
    font-size: 12px;
    color: #8B8C8D;
    line-height: 14px;
}
</style>